import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Messages from "../../common/messages/Messages";
import * as projectActions from "../../../actions/project.actions";
import * as commonActions from "../../../actions/common.actions";

import CompleteProjectModal from "../../common/completeProjectModal/CompleteProjectModal";
import declineModal from "../memberProfile/components/declineModal";
import hireModal from "../memberProfile/components/hireModal";
import acceptModal from "../memberProposal/components/acceptModal";
import requestEditModal from "../memberProposal/components/requestEditModal";

const subHeader = (pitchId, memberId, projectId) => {
  return {
    items: [
      {
        caption: "Member Profile",
        url: `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/memberProfile`
      },
      {
        caption: "Statement of Work",
        url: `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/sow`
      },
      {
        caption: "Messages",
        url: `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/messages`
      }
    ],
    activeItem: 2
  };
};

const pitchPending = (hireMember, declineMember) => ({
  color: "blue",
  title: "This Member Has Pitched Your Project",
  text: (
    <span>
      Click Hire to decline all other member pitches and move this member to the
      Statement of Work phase.
    </span>
  ),
  buttons: [
    {
      text: "Decline",
      type: "modalTrigger",
      modal: declineModal,
      modalClick: declineMember
    },
    {
      text: "Hire",
      type: "modalTrigger",
      color: "blue",
      modal: hireModal,
      modalClick: hireMember
    }
  ]
});

const pitchDeclined = () => ({
  center: false,
  color: "grey",
  title: "The Pitch is Declined",
  text: "You declined this pitch"
});

const awaitingSow = memberName => ({
  color: "blue",
  title: `You have selected ${memberName}`,
  text: `We have alerted her to submit her SOW for this project.
    When she completes it, we will notify you by email.`
});

// const sowEdisRequestedHeaderBar = () => ({
//   center: true,
//   color: 'grey',
//   title: 'The Member has been notified that you requested modifications. '
// });

const sowApprovedHeaderBar = (completeProject, projectId) => ({
  center: false,
  color: "grey",
  title: "Your Project is Underway",
  text: `After you’ve completed the project,
   click the button on the right to kick off the invoicing and review process.`,
  buttons: [
    {
      text: "Complete Project",
      type: "modalTrigger",
      modalProps: {
        completeProject,
        projectId
      },
      modal: CompleteProjectModal
    }
  ]
});

const projectCompletedHeaderBar = completeProject => ({
  center: false,
  color: "grey",
  title: "The project has been completed.",
  buttons: [
    {
      text: "Submit Feedback",
      onClick: completeProject
    }
  ]
});

const sowPendingApprovalHeaderBar = (acceptSow, requestEdit) => ({
  color: "blue",
  title: "SOW in Draft",
  text: `The Member has submitted the SOW below. If it’s ready, hit “Accept”.
  Otherwise, hit “Request Edits” to message her about changes.`,
  buttons: [
    {
      text: "Request Edits",
      type: "modalTrigger",
      color: "blue",
      modal: requestEditModal,
      modalClick: requestEdit
    },
    {
      text: "Accept",
      type: "modalTrigger",
      modal: acceptModal,
      modalClick: acceptSow
    }
  ]
});

class EmployerMessagesContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentMemberProjectState: null,
      sow: null,
      member: null
    };

    this.acceptSow = this.acceptSow.bind(this);
    this.completeProject = this.completeProject.bind(this);
    this.declineMember = this.declineMember.bind(this);
    this.hireMember = this.hireMember.bind(this);
    this.requestEdit = this.requestEdit.bind(this);
  }

  componentDidMount() {
    const { pitchId, memberId, projectId } = this.props.match.params;

    this.props.projectActions.getMember(memberId);
    this.props.projectActions.getPitch(pitchId);
    this.props.projectActions.getProject(projectId);
    this.props.projectActions.getMessagesByPitchId(pitchId);

    this.props.commonActions.setSubHeader(
      subHeader(pitchId, memberId, projectId)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    this.setHeaderBar(prevProps, prevState);
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
    this.props.commonActions.setHeaderBar({});
  }

  setHeaderBar(prevProps, prevState) {
    if (!_.isEmpty(this.props.pitch) && this.props.pitch !== prevProps.pitch) {
      const member = this.props.member;
      const pitch = this.props.pitch;
      const sow = _.get(pitch, "sow");

      const pitchAccepted = _.get(pitch, "accepted");
      const sowPendingApproval = pitchAccepted && sow;
      const sowApproved = _.get(sow, "accepted");

      let headerBar = {};
      let currentEmployerProjectState = null;

      if (sowApproved) {
        // SOW Approved
        currentEmployerProjectState = "sowApproved";

        if (this.props.project) {
          switch (this.props.project.status.name) {
            case "completed":
              headerBar = projectCompletedHeaderBar(this.completeProject);
              break;

            case "reviewed":
              break;

            default:
              headerBar = sowApprovedHeaderBar(this.completeProject);
              break;
          }
        } else {
          headerBar = sowApprovedHeaderBar(this.completeProject);
        }
      } else if (sowPendingApproval) {
        //Awaiting for employer to approved the SOW
        currentEmployerProjectState = "sowPendingApproval";
        headerBar = sowPendingApprovalHeaderBar(
          this.acceptSow,
          this.requestEdit
        );
      } else if (pitchAccepted) {
        //Awaiting for member to send the SOW
        currentEmployerProjectState = "pitchAccepted";
        headerBar = awaitingSow(_.get(member, "first_name"));
      } else if (pitchAccepted === false) {
        currentEmployerProjectState = "pitchDeclined";
        headerBar = pitchDeclined();
      } else if (pitchAccepted === null) {
        //Pitch Pending
        currentEmployerProjectState = "pitchPending";
        headerBar = pitchPending(this.hireMember, this.declineMember);
      }

      if (
        currentEmployerProjectState !== prevState.currentEmployerProjectState ||
        sow !== prevState.msow
      ) {
        this.props.commonActions.setHeaderBar(headerBar);
        this.setState({ currentEmployerProjectState, sow, member });
      }
    }
  }

  acceptSow() {
    const payload = {
      sow_id: this.state.sow.id,
      accepted: true
    };

    this.props.projectActions.acceptSow(payload, this.props.pitch.id);
  }

  completeProject() {
    this.props.projectActions.completeProjectByEmployer(
      this.props.project.id,
      this.props.member.id
    );
  }

  declineMember(message) {
    const payload = {
      pitch_id: this.props.pitch.id,
      message: message,
      accept: false
    };
    this.props.projectActions.acceptPitch(payload);
  }

  hireMember() {
    const payload = {
      pitch_id: this.props.pitch.id,
      accept: true
    };
    this.props.projectActions.acceptPitch(payload);
  }

  requestEdit(message) {
    const payload = {
      sow_id: this.state.sow.id,
      edits_requested: true,
      message
    };

    this.props.projectActions.acceptSow(payload, this.props.pitch.id);
  }

  render() {
    const messages = this.props.messages || {};
    const pitch = this.props.pitch || {};
    const { memberId } = this.props.match.params;

    return (
      <Messages
        disabled={!messages[0]}
        pitchId={pitch.id}
        memberId={memberId}
        messages={messages}
        matchDate={pitch.match && pitch.match.created_at}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.project.data.data,
    pitch: state.project.pitch,
    member: state.project.member,
    messages: state.project.messages
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployerMessagesContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/EmployerMessagesContainer/EmployerMessagesContainer.js